module.exports = __webpack_public_path__ + "static/media/factory-placeholder.e95904e9.svg";